import { SKINS } from '@/consts/skins.const';
import { getInitialLocale } from '@/utils/get-initial-locale';

import { actions } from './actions';
import { getters } from './getters';
import { mutations } from './mutations';

export const Broker = {
  actions,
  getters,
  mutations,
  state: {
    data: {
      countries: [],
      selectedCountry: '',
      validationType: '',
      documentsForValidation: [],
      locale: getInitialLocale(),
      skin: SKINS.whitelabel,
      additionalDriver: '',
      additionalDriverFeatureEnabled: false,
      customerCode: '',
      requiredAutoValidation: false,
      vehicleImageUrl: '',
      pickupOffice: '',
      returnOffice: '',
      startDateTime: '',
      returnDateTime: '',
      alreadyValidated: false,
      reservationId: '',
      channel: '',
      pickupCountryCode: '',
      dropoffCountryCode: '',
    },
    client: {
      clientData: {
        name: '',
        surname: '',
        nationality: '',
        address: '',
        postalCode: '',
        city: '',
        province: '',
        country: '',
        gender: '',
        phoneNumber: '',
        birthDay: '',
        licenseId: '',
        licenseType: '',
        licenseExpeditionCountry: '',
        drivingLicenseExpirationDate: '',
        idNumber: '',
        passport: '',
        nifExpirationDate: '',
        passportExpirationDate: '',
      },
      clientDocument: {
        documentRequired: [],
        onlyMandatoryFieldsMissing: false,
        optionalDocuments: [],
      },
    },
  },
} as const;
